'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('workorder-code-edit', {
      url: '/workorder/code/edit/:id',
      template: '<work-order-code-edit></work-order-code-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/workorders/code-edit/workorders-code-edit.routes.js